export const statuses = [
  'finished',
  'in_progress',
  'pre_game',
  'removed',
  'suspended'
] as const;
